import { render } from "./CompanyMaint.vue?vue&type=template&id=06aa4de0&scoped=true"
import script from "./CompanyMaint.vue?vue&type=script&lang=js"
export * from "./CompanyMaint.vue?vue&type=script&lang=js"

import "./CompanyMaint.vue?vue&type=style&index=0&id=06aa4de0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06aa4de0"]])

export default __exports__